(() => {
  if (window.clicksterValidationInstalled) return;
  window.clicksterValidationInstalled = true;

  const ROOT = '[data-clickster-personalisation]';

  // FIND SELECTED SIZE
  function getSize(root) {
    const pickers = document.querySelectorAll(
      'variant-picker[data-product-id]'
    );

    const picker = [...pickers].find(el =>
      el.dataset.productId === root.dataset.productId &&
      el.closest('.shopify-section') ===
        root.closest('.shopify-section')
    ) || [...pickers].find(el =>
      el.dataset.productId === root.dataset.productId
    );

    if (!picker) return null;

    const selects = picker.querySelectorAll(
      'select.variant-option__select'
    );

    for (const select of selects) {
      if (!/size/i.test(select.name)) continue;

      const match = select.value.match(
        /^(\d+)\s+(?:Letters?|Keys?)\b/i
      );

      if (match) return Number(match[1]);
    }

    const radios = picker.querySelectorAll(
      'input[type="radio"]:checked'
    );

    for (const radio of radios) {
      if (!/size/i.test(
        radio.dataset.optionName || ''
      )) continue;

      const match = radio.value.match(
        /^(\d+)\s+(?:Letters?|Keys?)\b/i
      );

      if (match) return Number(match[1]);
    }

    return null;
  }

  // COUNT ICONS
  function getIcons(value) {
    return value.split(',')
      .map(icon => icon.trim())
      .filter(Boolean);
  }

  // DISPLAY OR HIDE AN ERROR
  function setError(element, message) {
    if (!element) return;

    element.textContent = message || '';
    element.hidden = !message;
  }

  // SHOW OR HIDE ICON PLACEMENT
  function updateIconPlacement(root) {
    const name = root.querySelector(
      '[data-clickster-name]'
    );

    const icons = root.querySelector(
      '[data-clickster-icons]'
    );

    const placementSection = root.querySelector(
      '[data-clickster-icon-placement]'
    );

    const customSection = root.querySelector(
      '[data-clickster-custom-placement]'
    );

    const placementOptions = root.querySelectorAll(
      '[data-icon-placement-option]'
    );

    const customInput = root.querySelector(
      '[data-clickster-placement-details]'
    );

    if (
      !name ||
      !icons ||
      !placementSection ||
      !customSection ||
      !customInput
    ) return;

    const hasName = name.value.trim().length > 0;
    const hasIcons = getIcons(icons.value).length > 0;
    const showPlacement = hasName && hasIcons;

    placementSection.hidden = !showPlacement;

    placementOptions.forEach(option => {
      option.disabled = !showPlacement;

      if (!showPlacement) {
        option.checked = false;
      }
    });

    const selected = root.querySelector(
      '[data-icon-placement-option]:checked'
    );

    const showCustom = Boolean(
      showPlacement &&
      selected &&
      selected.value === 'Custom placement'
    );

    customSection.hidden = !showCustom;
    customInput.disabled = !showCustom;

    // Use our own error messages rather than browser popups.
    customInput.required = false;

    if (!showCustom) {
      customInput.value = '';
    }
  }

  // VALIDATE PERSONALISATION
  function validate(root, showError = false) {
    const name = root.querySelector(
      '[data-clickster-name]'
    );

    const icons = root.querySelector(
      '[data-clickster-icons]'
    );

    const counter = root.querySelector(
      '[data-clickster-counter]'
    );

    const keyError = root.querySelector(
      '[data-clickster-error]'
    );

    const placementError = root.querySelector(
      '[data-clickster-placement-error]'
    );

    const customError = root.querySelector(
      '[data-clickster-custom-error]'
    );

    const customInput = root.querySelector(
      '[data-clickster-placement-details]'
    );

    if (
      !name ||
      !icons ||
      !counter ||
      !keyError ||
      !placementError ||
      !customError
    ) {
      return false;
    }

    // UPPERCASE NAME WITHOUT DELETING LETTERS
    name.value = name.value.toUpperCase()
      .replace(/[^A-Z]/g, '');

    name.removeAttribute('maxlength');

    updateIconPlacement(root);

    const size = getSize(root);
    const iconList = getIcons(icons.value);
    const iconCount = iconList.length;
    const total = name.value.length + iconCount;

    // RESET WARNINGS
    name.classList.remove('clickster-input-warning');
    icons.classList.remove('clickster-input-warning');
    counter.classList.remove('clickster-counter-warning');

    setError(keyError, '');
    setError(placementError, '');
    setError(customError, '');

    // NO SIZE SELECTED
    if (!size) {
      counter.textContent = 'Select your size above';

      if (showError) {
        setError(keyError, 'Please select your size.');
      }

      return false;
    }

    const tooManyKeys = total > size;
    const validSize = total === size;

    counter.textContent =
      total + ' / ' + size + ' keys';

    // HIGHLIGHT IF TOO MANY KEYS
    name.classList.toggle(
      'clickster-input-warning',
      tooManyKeys
    );

    icons.classList.toggle(
      'clickster-input-warning',
      tooManyKeys
    );

    counter.classList.toggle(
      'clickster-counter-warning',
      tooManyKeys
    );

    // KEY COUNT ERROR
    if (tooManyKeys) {
      setError(
        keyError,
        'You have entered ' + total +
        ' keys, but selected ' + size +
        '. Please remove a letter or icon, or choose a larger size.'
      );
    } else if (!validSize && showError) {
      setError(
        keyError,
        'Please enter exactly ' + size +
        ' letters and icons in total.'
      );
    }

    // ICON PLACEMENT VALIDATION
    let validPlacement = true;
    let validCustom = true;

    if (name.value.length > 0 && iconCount > 0) {
      const selected = root.querySelector(
        '[data-icon-placement-option]:checked'
      );

      if (!selected) {
        validPlacement = false;

        if (showError) {
          setError(
            placementError,
            'Please select where you would like your icons placed.'
          );
        }

      } else if (selected.value === 'Custom placement') {
        if (!customInput || !customInput.value.trim()) {
          validCustom = false;

          if (showError) {
            setError(
              customError,
              'Please tell us where you would like your icons placed.'
            );
          }
        }
      }
    }

    return validSize && validPlacement && validCustom;
  }

  // FIND MATCHING PRODUCT FORM
  function getRootForForm(form) {
    return [...document.querySelectorAll(ROOT)]
      .find(root => {
        const name = root.querySelector(
          '[data-clickster-name]'
        );

        return name && name.form === form;
      });
  }

  // LIVE VALIDATION WHILE TYPING
  document.addEventListener('input', event => {
    const root = event.target.closest(ROOT);

    if (root) {
      validate(root);
    }
  });

  // VALIDATE WHEN OPTIONS CHANGE
  document.addEventListener('change', event => {
    const root = event.target.closest(ROOT);

    if (root) {
      validate(root);
      return;
    }

    const picker = event.target.closest(
      'variant-picker'
    );

    if (!picker) return;

    document.querySelectorAll(ROOT).forEach(root => {
      if (
        root.dataset.productId ===
        picker.dataset.productId
      ) {
        validate(root);
      }
    });
  });

  // BLOCK INVALID FORM SUBMISSION
  document.addEventListener('submit', event => {
    const root = getRootForForm(event.target);

    if (!root) return;

    if (!validate(root, true)) {
      event.preventDefault();
      event.stopImmediatePropagation();

      root.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, true);

  // BLOCK INVALID ADD TO CART CLICKS
  document.addEventListener('click', event => {
    const button = event.target.closest(
      'button[type="submit"], input[type="submit"]'
    );

    if (!button || !button.form) return;

    const root = getRootForForm(button.form);

    if (!root) return;

    if (!validate(root, true)) {
      event.preventDefault();
      event.stopImmediatePropagation();

      root.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, true);

  // INITIALISE
  function refresh() {
    document.querySelectorAll(ROOT).forEach(
      root => validate(root)
    );
  }

  document.addEventListener(
    'DOMContentLoaded',
    refresh
  );

  document.addEventListener(
    'shopify:section:load',
    refresh
  );

  if (document.readyState !== 'loading') {
    refresh();
  }
})();